import { Grid, TextArea } from '@radix-ui/themes';
import PropTypes from 'prop-types';
import React from 'react';
import { StyledTextFieldRoot } from '~/components/Input/Elements/TextField';
import InputFieldWrapper from '~/components/InputFieldWrapper';
import { SignUpCardSubtitle, SignUpCardTitle } from '~/components/Text';
import { ContinueBtn, StyledContinueBtnWrapper, StyledForm, SubTitleWrapper } from './components/Elements';

function FillUserInfo({
  formData,
  setFormData,
  unsafeMetadata,
  setUnsafeMetadata,
  errors,
  setErrors,
  nextStep,
  RenderBackButton,
}) {
  return (
    <>
      <SignUpCardTitle>Company information</SignUpCardTitle>
      <SubTitleWrapper>
        <SignUpCardSubtitle>Please provide some details about your company.</SignUpCardSubtitle>
      </SubTitleWrapper>
      <StyledForm>
        <InputFieldWrapper
          label='Company name'
          errorText={errors.companyName}
        >
          <StyledTextFieldRoot
            autoFocus
            color='gray'
            size='2'
            name='company-name'
            placeholder='Enter company name'
            onChange={e => {
              setUnsafeMetadata(prev => ({ ...prev, companyName: e.target.value }));
              setErrors(prev => ({ ...prev, companyName: null }));
            }}
            value={unsafeMetadata.companyName}
          />
        </InputFieldWrapper>
        <InputFieldWrapper
          label='Use case'
          errorText={errors.useCase}
          optional
        >
          <TextArea
            color='gray'
            size='2'
            name='use-case'
            placeholder='Describe your use case'
            optional
            onChange={e => {
              setUnsafeMetadata(prev => ({ ...prev, useCase: e.target.value }));
              setErrors(prev => ({ ...prev, useCase: null }));
            }}
            value={unsafeMetadata.useCase}
            error={!!errors.useCase}
          />
        </InputFieldWrapper>
        <Grid
          columns='2'
          gapX='2'
        >
          <InputFieldWrapper
            label='First name'
            errorText={errors.firstName}
          >
            <StyledTextFieldRoot
              color='gray'
              size='2'
              name='first-name'
              placeholder='Enter first name'
              onChange={e => {
                setFormData(prev => ({ ...prev, firstName: e.target.value }));
                setErrors(prev => ({ ...prev, firstName: null }));
              }}
              value={formData.firstName}
              error={!!errors.firstName}
            />
          </InputFieldWrapper>
          <InputFieldWrapper
            label='Surname'
            errorText={errors.lastName}
          >
            <StyledTextFieldRoot
              color='gray'
              size='2'
              name='last-name'
              placeholder='Enter surname'
              onChange={e => {
                setFormData(prev => ({ ...prev, lastName: e.target.value }));
                setErrors(prev => ({ ...prev, lastName: null }));
              }}
              value={formData.lastName}
              error={!!errors.lastName}
            />
          </InputFieldWrapper>
        </Grid>
        <InputFieldWrapper
          label='Job title'
          errorText={errors.jobTitle}
        >
          <StyledTextFieldRoot
            color='gray'
            size='2'
            name='job-title'
            placeholder='Enter Job Title'
            onChange={e => {
              setUnsafeMetadata(prev => ({ ...prev, jobTitle: e.target.value }));
              setErrors(prev => ({ ...prev, jobTitle: null }));
            }}
            value={unsafeMetadata.jobTitle}
            error={!!errors.jobTitle}
          />
        </InputFieldWrapper>
        <InputFieldWrapper
          label='How did you hear about us?'
          errorText={errors.heardAboutOnomondoFrom}
        >
          <StyledTextFieldRoot
            color='gray'
            size='2'
            placeholder='Webinars, social media, events, referrals...'
            onChange={e => {
              setUnsafeMetadata({ ...unsafeMetadata, heardAboutOnomondoFrom: e.target.value });
              setErrors({ ...errors, heardAboutOnomondoFrom: '' });
            }}
            value={unsafeMetadata.heardAboutOnomondoFrom}
            error={!!errors.heardAboutOnomondoFrom}
          />
        </InputFieldWrapper>
        <StyledContinueBtnWrapper>
          <ContinueBtn onClick={nextStep}>Continue</ContinueBtn>
        </StyledContinueBtnWrapper>
        <RenderBackButton />
      </StyledForm>
    </>
  );
}

FillUserInfo.propTypes = {
  formData: PropTypes.object,
  setFormData: PropTypes.func,
  errors: PropTypes.object,
  setErrors: PropTypes.func,
  unsafeMetadata: PropTypes.object,
  setUnsafeMetadata: PropTypes.func,
  nextStep: PropTypes.func,
  RenderBackButton: PropTypes.func,
};

export default FillUserInfo;
